import React from 'react';
import Typography from '@mui/material/Typography';

const BodyCopy = (props) => {
  const { color, children, ...rest } = props;
  return (
    <Typography
      {...rest}
      color={color}
      sx={[{
        fontSize: '18px',
        fontWeight: '400',
        lineHeight: '28px'
      }, ...(Array.isArray(rest.sx) ? rest.sx : [rest.sx])]}>
      {children}
    </Typography>
  );
};

export default BodyCopy;
